import { render, staticRenderFns } from "./tournament-matches.vue?vue&type=template&id=53c27cee&"
import script from "./tournament-matches.vue?vue&type=script&lang=js&"
export * from "./tournament-matches.vue?vue&type=script&lang=js&"
import style0 from "./tournament-matches.vue?vue&type=style&index=0&id=53c27cee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports